import * as PIXI from 'pixi.js';
import gsap from "gsap";
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import Player from "./Player";
import Tools from '../utils/Tools';

export default class Configuration extends PIXI.Container {
    constructor() {
        super();
        // Status
        this.isConfigurationOn = false;
        this.isSoundOn = true;
        this.isHapticOn = true;

        this.configurationButton = null;
        this.soundOnButton = null;
        this.soundOffButton = null;
        this.hapticOnButton = null;
        this.hapticOffButton = null;

        this.onClickConfigurationButton = this.onClickConfigurationButton.bind(this);
        this.onClickSoundOnButton = this.onClickSoundOnButton.bind(this);
        this.onClickSoundOffButton = this.onClickSoundOffButton.bind(this);
        this.onClickHapticOnButton = this.onClickHapticOnButton.bind(this);
        this.onClickHapticOffButton = this.onClickHapticOffButton.bind(this);

        // Initialize all the configuration buttons
        this.initButton();
    }

    initButton() {
        // Initialize the sound on button
        const soundOnButtonTexture = AssetsManager.texturesPixi.iconsound;
        this.soundOnButton = new PIXI.Sprite(soundOnButtonTexture);
        this.soundOnButton.interactive = true;
        this.soundOnButton.buttonMode = true;
        this.soundOnButton.on("pointerdown", this.onClickSoundOnButton);
        this.soundOnButton.scale.set(0.15);
        this.soundOnButton.x = 10;
        this.soundOnButton.y = 145;
        this.soundOnButton.visible = false;
        this.addChild(this.soundOnButton);

        // Initialize the sound off button
        const soundOffButtonTexture = AssetsManager.texturesPixi.iconmute;
        this.soundOffButton = new PIXI.Sprite(soundOffButtonTexture);
        this.soundOffButton.interactive = true;
        this.soundOffButton.buttonMode = true;
        this.soundOffButton.on("pointerdown", this.onClickSoundOffButton);
        this.soundOffButton.scale.set(0.15);
        this.soundOffButton.x = 10;
        this.soundOffButton.y = 145;
        this.soundOffButton.visible = false;
        this.addChild(this.soundOffButton);

        // Initialize the haptic on button
        const hapticOnButtonTexture = AssetsManager.texturesPixi.iconvibrations;
        this.hapticOnButton = new PIXI.Sprite(hapticOnButtonTexture);
        this.hapticOnButton.interactive = true;
        this.hapticOnButton.buttonMode = true;
        this.hapticOnButton.on("pointerdown", this.onClickHapticOnButton);
        this.hapticOnButton.scale.set(0.15);
        this.hapticOnButton.x = 10;
        this.hapticOnButton.y = 195;
        this.hapticOnButton.visible = false;
        //this.addChild(this.hapticOnButton);

        // Initialize the haptic off button
        const hapticOffButtonTexture = AssetsManager.texturesPixi.iconnovibrations;
        this.hapticOffButton = new PIXI.Sprite(hapticOffButtonTexture);
        this.hapticOffButton.interactive = true;
        this.hapticOffButton.buttonMode = true;
        this.hapticOffButton.on("pointerdown", this.onClickHapticOffButton);
        this.hapticOffButton.scale.set(0.15);
        this.hapticOffButton.x = 10;
        this.hapticOffButton.y = 195;
        this.hapticOffButton.visible = false;
        //this.addChild(this.hapticOffButton);

        // Initialize the configuration button
        const configButtonTexture = AssetsManager.texturesPixi.icongear;
        this.configurationButton = new PIXI.Sprite(configButtonTexture);
        this.configurationButton.interactive = true;
        this.configurationButton.buttonMode = true;
        this.configurationButton.on("pointerdown", this.onClickConfigurationButton);
        this.configurationButton.scale.set(0.15);
        this.configurationButton.x = 10;
        this.configurationButton.y = 80;
        this.addChild(this.configurationButton);
    }

    onClickConfigurationButton() {
        if (this.isConfigurationOn) {
            gsap.fromTo(this.soundOnButton, { y: 145 }, { y: 95, duration: 0.25 });
            gsap.fromTo(this.soundOffButton, { y: 145 }, { y: 95, duration: 0.25 });
            gsap.fromTo(this.hapticOnButton, { y: 195 }, { y: 95, duration: 0.25 });
            gsap.fromTo(this.hapticOffButton, { y: 195 }, { y: 95, duration: 0.25 });

            gsap.delayedCall(0.2, () => {
                this.soundOnButton.visible = false;
                this.soundOffButton.visible = false;
                this.hapticOnButton.visible = false;
                this.hapticOffButton.visible = false;
            });

            this.isConfigurationOn = false;
        }
        else {
            gsap.fromTo(this.soundOnButton, { y: 95 }, { y: 145, duration: 0.25 });
            gsap.fromTo(this.soundOffButton, { y: 95 }, { y: 145, duration: 0.25 });
            gsap.fromTo(this.hapticOnButton, { y: 95 }, { y: 195, duration: 0.25 });
            gsap.fromTo(this.hapticOffButton, { y: 95 }, { y: 195, duration: 0.25 });

            if (this.isSoundOn) {
                this.soundOnButton.visible = true;
            }
            else {
                this.soundOffButton.visible = true;
            }

            if (this.isHapticOn) {
                this.hapticOnButton.visible = true;
            }
            else {
                this.hapticOffButton.visible = true;
            }

            this.isConfigurationOn = true;
        }
    }

    onClickSoundOnButton() {
        this.soundOnButton.visible = false;
        this.soundOffButton.visible = true;
        this.isSoundOn = false;

        GameManager.soundManager.setAudioEnabled(false);
    }

    onClickSoundOffButton() {
        this.soundOffButton.visible = false;
        this.soundOnButton.visible = true;
        this.isSoundOn = true;

        GameManager.soundManager.setAudioEnabled(true);
    }

    onClickHapticOnButton() {
        this.hapticOnButton.visible = false;
        this.hapticOffButton.visible = true;
        this.isHapticOn = false;

        GameManager.hapticManager.setHapticEnabled(false);
    }

    onClickHapticOffButton() {
        this.hapticOffButton.visible = false;
        this.hapticOnButton.visible = true;
        this.isHapticOn = true;

        GameManager.hapticManager.setHapticEnabled(true);
    }

}